import { useObserver } from "mobx-react";
import {
  AiFillCloseCircle,
  AiOutlineClockCircle,
  AiOutlineCloseCircle,
} from "react-icons/ai";
import { useStores } from "../../store";
import {
  IoCheckmarkCircleOutline,
  IoInformationCircleOutline,
  IoWarningOutline,
} from "react-icons/io5";
import {
  OutLinedHoverButton,
  PrimaryButton,
} from "../reusble_components/buttons/primaryButton";
import { OutlineButton } from "../reusble_components/buttons/OutlineButton";
import { useNavigate } from "react-router-dom";
import { MdOutlineWarning } from "react-icons/md";

export default function EmailSent({ close = true }) {
  const { PopupStore } = useStores();
  const navigate = useNavigate();
  const closeThisPopUP = () => {
    PopupStore.setEmailPopup(false);
  };
  return useObserver(() => {
    return (
      <>
        {PopupStore.emailPopup && (
          <div
            onClick={() => closeThisPopUP}
            className="fixed w-screen h-screen z-40 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="absolute  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-xl items-center md:w-[45%] lg:w-[35%] w-[90%] h-[35%] md:h-[35%] lg:h-[30%] m-auto shadow-lg overflow-y-auto no-scrollbar"
            >
              <div className="flex flex-col justify-center items-center p-6 h-full w-full border relative">
                {close && (
                  <AiOutlineCloseCircle
                    className="absolute text-xl cursor-pointer top-2 right-2"
                    onClick={closeThisPopUP}
                  />
                )}
                <div
                  className="flex flex-col items-center w-full gap-4 overflow-auto"
                  style={{
                    scrollbarWidth: "thin", // Ensures the scrollbar is visible
                    scrollbarColor: "#ccc transparent",
                  }}
                >
                  <h1 className="text-xl font-semibold text-center">
                    Thanks for your registration, please check your inbox!
                  </h1>

                  <p className="text-center">
                    Thanks for registering with{" "}
                    <a className="text-primary" href="https://reaidy.io">
                      REAIDY.IO!
                    </a>
                    <br />
                    Please check your inbox for a confirmation email from
                    <a
                      className="mx-2 text-primary"
                      href="mailto:reaidy.noreply@gmail.com"
                    >
                      reaidy.noreply@gmail.com
                    </a>
                    . If it's not there, check your spam folder. Click the link
                    mentioned in the email to complete your registration.
                    <br />
                    Contact us at{" "}
                    <a className="text-primary" href="mailto:connect@reaidy.io">
                      connect@reaidy.io
                    </a>{" "}
                    if you need any help.
                  </p>
                </div>
                <style jsx>{`
                  div::-webkit-scrollbar {
                    width: 8px;
                  }

                  div::-webkit-scrollbar-track {
                    background: #f0f0f0;
                    border-radius: 4px;
                  }

                  div::-webkit-scrollbar-thumb {
                    background: #888;
                    border-radius: 4px;
                  }

                  div::-webkit-scrollbar-thumb:hover {
                    background: #555;
                  }
                `}</style>
              </div>
            </div>
          </div>
        )}
      </>
    );
  });
}
